
import React from "react";
import { Button } from "@/components/ui/button";
import { Send } from "lucide-react";

interface SubmitButtonProps {
  isLoading: boolean;
  isProcessingAudio: boolean;
  isRecording: boolean;
  isDisabled: boolean;
}

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  isLoading,
  isProcessingAudio,
  isRecording,
  isDisabled
}) => {
  return (
    <Button
      type="submit"
      disabled={isDisabled}
      className="px-4"
    >
      {isLoading ? (
        <span className="flex items-center gap-1">
          <span className="animate-pulse">Chargement...</span>
        </span>
      ) : isProcessingAudio ? (
        <span className="flex items-center gap-1">
          <span className="animate-pulse">Traitement...</span>
        </span>
      ) : isRecording ? (
        <span className="flex items-center gap-1">
          <Send className="h-4 w-4 mr-1" />
          Traiter l'audio
        </span>
      ) : (
        <span className="flex items-center gap-1">
          <Send className="h-4 w-4 mr-1" />
          Envoyer
        </span>
      )}
    </Button>
  );
};
